import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./auth.service";

export const AuthGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const isLoginPage = route.routeConfig?.path === "login";

    const isAuth = authService.isAuthenticated();
    if (isAuth) {
        if (isLoginPage) {
            return router.createUrlTree(["/dashboard"]);
        }
        return true;
    } else {
        if (!isLoginPage) {
            return router.createUrlTree(["/login"]);
        }
        return true;
    }
};
